// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__rrx8j","rotate":"Preloader_rotate__Piu5w"};